<script lang="ts">
    import { inject, reactive, Ref, ref, toRaw } from 'vue';
    import vm from '@journeys/Journeys.viewmodel';

    // utils
    import { bitshift, uid, deepClone } from '@utils';

    // components
    import Toolbar from './Toolbar.vue';
    import Topbar from './Topbar.vue';
    import SidebarMain from './SidebarMain.vue';
    import PropertyWindow from './PropertyWindow.vue';
    import Scrollbar3d from '@shared/components/Scrollbar3d.vue';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { SegmentAccess } from '@cwd/Views/Segments/Segments.access';

    // this is mostly for debugging, otherwise components are Anonymous
    export default {
        name: 'UI_RootContainer',
    };
</script>

<script lang="ts" setup>
    const { nav, canvas, settings, viewport, editor } = vm;
</script>

<template>
    <div class="ui-container">
        <PropertyWindow />

        <Toolbar />
        <Topbar />

        <SidebarMain />

        <!--
        <div class="dev-btm"><h4>{{ editor.dev.bidi?.data }}</h4></div>
        -->
    </div>

    <!-- annoying chrome autofill fix (has to be the last element) -->
    <input style="position: absolute; pointer-events: none; opacity: 0" type="hidden" />
</template>

<style>
    .dev-btm {
        display: block;
        position: absolute;
        bottom: 1rem;
        left: 0;
        min-height: 2rem;
        min-width: calc(16rem + 4vw);

        border-radius: 6px;
        background-color: rgba(94, 105, 115, 0.029);
    }

    .dev-btm h4 {
        color: rgb(13, 18, 14);
        font-weight: 600;
    }

    .ui-container {
        z-index: 1;
    }

    .section-group {
        clear: both;
        margin-bottom: 1.2rem;
    }

    /* remove the default number input buttons */
    /*
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
        appearance: none !important;
        margin: 0 !important;
    }
    
    input[type='number'] {
        -moz-appearance: textfield !important;
        appearance: textfield !important;
    }
    */
</style>
